export const FuelStationParameter = {
    CompanyName: 'CompanyName',
    FantasyName: 'FantasyName',
    StationName: 'StationName'
};



// WEBPACK FOOTER //
// ./src/constants/fuelStationParameter.js